// extracted by mini-css-extract-plugin
module.exports = {"searchSuggestion":"SearchQuerySuggestion_searchSuggestion__BKIWB"};